import React, { useEffect } from 'react';
import Layout from '@/components/layout/Layout';
import Seo from '@/components/common/Seo';
import { useTranslation } from '@/hooks/useTranslation';

// Importiere alle Sektionen
import HeaderSection from './HeaderSection';
import ProofSection from './ProofSection';
import PainSection from './PainSection';
import FeaturesSection from './FeaturesSection';
import CloudSection from './CloudSection';
import ProcessSection from './ProcessSection';
import ServiceModelsSection from './ServiceModelsSection';
import FoundersSection from './FoundersSection';

// Registriere die Übersetzungen
import translations from './translations';
import { registerTranslations } from '@/hooks/useTranslation';
import ContactForm from '@/components/common/ContactForm';

// Registriere die Übersetzungen für diese Seite
registerTranslations('erpPage', translations);

const ErpPage = () => {
  const { t } = useTranslation();
  
  // Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Seo 
        title="Microsoft Dynamics 365 Business Central | Cloud-ERP für den Mittelstand"
        description="Microsoft Dynamics 365 Business Central - das cloud-basierte ERP-System für den Mittelstand. Alle Geschäftsprozesse in einer Plattform. Jetzt 30 Tage kostenlos testen!"
        canonical="/erp"
      />
      <Layout>
        <main>
          <HeaderSection />
          <ProofSection />
          <PainSection />
          <FeaturesSection />
          <CloudSection />
          <ProcessSection />
          <ServiceModelsSection />
          <FoundersSection />
          <ContactForm />
        </main>
      </Layout>
    </>
  );
};

export default ErpPage; 